// Org role Config files
import orgNotAdminConfig from "config/appConfigFiles/orgNotAdmin.json";

// Map role Config files
import roleViewerConfig from "config/appConfigFiles/roleViewer.json";
import roleNoteConfig from "config/appConfigFiles/roleNote.json";
import roleEditorConfig from "config/appConfigFiles/roleEditor.json";
import roleAdminConfig from "config/appConfigFiles/roleAdmin.json";

// Project role Config files
import roleProjectViewerConfig from "config/appConfigFiles/roleProjectViewer.json";
import roleProjectNoteConfig from "config/appConfigFiles/roleProjectNote.json";
import roleProjectEditorConfig from "config/appConfigFiles/roleProjectEditor.json";
import roleProjectAdminConfig from "config/appConfigFiles/roleProjectAdmin.json";
import roleProjectBuyerConfig from "config/appConfigFiles/roleProjectBuyer.json";

// App type specific config files
import { getGeorgeSubscriptionConfig, getGeorgeSubscriptionOverride, getSubscriptionConfigDefinition, replaceConfigArrays } from "./composeAppConfig";

// Fallback for unrecognised subscription types.
import defaultConfig from "config/appConfigFiles/default.json";

// Types
import { AppConfig } from "types/appFunctionality";
import { RolesProps } from "types/estatesAndMap";
import { RoleTypes, Subscription } from "types/auth";
import { isArray, isEmpty, mergeWith, union } from "lodash";

export function getAppConfigFromMapRole(
  roles: { [key: string]: RolesProps } | undefined,
  userId: string,
  type: "map" | "project"
) {
  // Return if mapRoles not provided or user id not provided
  if (!roles || !userId) return roleViewerConfig;
  // Return viewer config if user is not registred in the map
  if (!roles[userId]) return roleViewerConfig;

  switch (roles[userId].role) {
    case "viewer": {
      if (type === "map") {
        return roleViewerConfig;
      }
      return roleProjectViewerConfig;
    }
    case "commentator": {
      if (type === "map") {
        return roleNoteConfig;
      }
      return roleProjectNoteConfig;
    }
    case "editor": {
      if (type === "map") {
        return roleEditorConfig;
      }
      return roleProjectEditorConfig;
    }
    case "admin": {
      if (type === "map") {
        return roleAdminConfig;
      }
      return roleProjectAdminConfig;
    }
    case "buyer": {
      if (type === "map") {
        return roleViewerConfig;
      }
      return roleProjectBuyerConfig;
    }
    default: {
      if (type === "map") {
        return roleViewerConfig;
      }
      return roleProjectViewerConfig;
    }
  }
}

export function getAppConfigFromSubscription(
  subscription: Subscription | undefined,
  userOrgRole?: "admin" | "not-admin",
  internalAppType?: string,
): AppConfig {
  // George profiles are selected from the organisation's assigned subscription.
  // Registered George subscriptions keep their functionality even on another branded entry point.
  if (internalAppType === "george" || getGeorgeSubscriptionOverride(subscription?.type)) {
    const config = getGeorgeSubscriptionConfig(subscription?.type);
    return !userOrgRole || userOrgRole === "not-admin"
      ? mergeWith({}, config, orgNotAdminConfig, replaceConfigArrays)
      : config;
  }
  const config = (getSubscriptionConfigDefinition(subscription?.type || "free")?.config ?? defaultConfig) as AppConfig;
  if (!userOrgRole || userOrgRole === "not-admin") {
    return mergeWith({}, config, orgNotAdminConfig, standardCustomizer);;
  }
  return config;
}

export function getAppConfigFromOrgRole(role: RoleTypes) {
  switch (role) {
    case "admin":
      return roleEditorConfig;
    case "not-admin":
      return orgNotAdminConfig;
    default:
      return orgNotAdminConfig;
  }
}

function standardCustomizer (objValue: any, srcValue: any) {
  if (isArray(srcValue) && isEmpty(srcValue)) return srcValue;
  if (isArray(objValue) && isArray(srcValue)) return union(objValue, srcValue);
};
